import { HypotheticalILITInsurancePolicyType } from '../HypotheticalILITModal.types';
import { MapHypotheticalInsuranceToDataInput } from '../HypotheticalILITModal.utils';

export function getExistingInsuranceDetails({
  formData,
  contextData,
}: MapHypotheticalInsuranceToDataInput): {
  existingInsurancePolicyHolderID?: string | undefined;
  existingInsurancePolicyID?: string | undefined;
  clearExistingInsurancePolicy?: boolean;
  error: string | null;
} {
  const {
    existingInsurancePolicyId: existingInsurancePolicyID,
    _hypotheticalInsurancePolicyType,
  } = formData;

  if (
    _hypotheticalInsurancePolicyType === HypotheticalILITInsurancePolicyType.New
  ) {
    return {
      clearExistingInsurancePolicy: true,
      error: null,
    };
  }

  if (!existingInsurancePolicyID) {
    return {
      error: 'Existing insurance policy is required.',
    };
  }

  const existingInsurancePolicy = contextData.existingPolicies.find(
    (policy) => policy.id === existingInsurancePolicyID
  );

  if (!existingInsurancePolicy) {
    return {
      existingInsurancePolicyID,
      error: 'Existing insurance policy not found.',
    };
  }

  // this should match the filter in HypotheticalILITModal.context
  const existingInsurancePolicyHolderID =
    existingInsurancePolicy.cltTrust?.entity?.id ||
    existingInsurancePolicy.crtTrust?.entity?.id ||
    existingInsurancePolicy.daf?.entity?.id ||
    existingInsurancePolicy.ilitTrust?.entity?.id ||
    existingInsurancePolicy.insurancePersonalAccount?.entity?.id ||
    existingInsurancePolicy.irrevocableTrust?.entity?.id ||
    existingInsurancePolicy.privateFoundation?.entity?.id ||
    existingInsurancePolicy.revocableTrust?.entity?.id ||
    existingInsurancePolicy.slatTrust?.entity?.id;

  if (!existingInsurancePolicyHolderID) {
    return {
      existingInsurancePolicyID,
      error: 'Existing insurance policy holder ID not found.',
    };
  }

  return {
    existingInsurancePolicyHolderID,
    existingInsurancePolicyID,
    error: null,
  };
}
